import React from "react";
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader.js";
import DarkFooter from "components/Footers/DarkFooter.js";
import Message from "./index-sections/NucleoIcons.js";
import CompleteExamples from "./index-sections/CompleteExamples.js";
import SignUp from "./index-sections/SignUp.js";
import YoutubeEmbed from "components/YTvideo";

function Index() {
  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });
  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <IndexHeader />
        <div className="main">
          <Message />
          <div className="container text-center mb-4">
            <div className="row justify-content-md-center">
              <div className="col-lg-8 col-md-12 mb-4 mb-sm-0">
              {/* <video controls autoplay="autoplay" muted>
                  <source src={require("assets/img/FIBS_Corporate_Video.mp4")} type="video/mp4" />
                  Your browser does not support the video tag.
                </video> */}
                <YoutubeEmbed embedId="0RrqXMYUiUE"/>
              </div>
            </div>
          </div>
          <CompleteExamples />
          <SignUp />
        </div>
        <DarkFooter />
      </div>
    </>
  );
}

export default Index;
